import { render, staticRenderFns } from "./BrainsChartSelector.vue?vue&type=template&id=1daa610a&scoped=true&"
import script from "./BrainsChartSelector.vue?vue&type=script&lang=js&"
export * from "./BrainsChartSelector.vue?vue&type=script&lang=js&"
import style0 from "./BrainsChartSelector.vue?vue&type=style&index=0&id=1daa610a&lang=scss&scoped=true&"
import style1 from "./BrainsChartSelector.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1daa610a",
  null
  
)

export default component.exports